import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { fetchStartRecovery } from '@/lib/api';
import { recoveryText } from '@/lib/startRecoveryCopy';
import styles from './StartRecoveryOffer.module.css';

export function StartRecoveryOffer({ sessionId, onNavigate }: { sessionId: string; onNavigate: (path: string) => void }) {
  const { i18n } = useTranslation();
  const q = useQuery({ queryKey: ['start-recovery', sessionId], queryFn: () => fetchStartRecovery(sessionId), retry: false, staleTime: 0 });
  if (!q.data?.eligible) return null;
  return <section className={styles.card}>
    <h2>{recoveryText(i18n.language, 0)}</h2>
    <p>{recoveryText(i18n.language, 1)}</p>
    <button type="button" onClick={() => onNavigate('/scan?recover=' + encodeURIComponent(sessionId))}>{recoveryText(i18n.language, 2)}</button>
  </section>;
}
